import React, { useState } from 'react';
import { space } from 'styled-system';
import { styled, Dropdown, DropdownMenu, SvgIcon, DropdownToggle } from '@teko/ui';
import { Flex } from '@teko/ds-mobile';
import Link from 'next/link';
import { Text } from '../Text/Text.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledDropdown = styled(Dropdown)(space, `
width: auto;
`);
const StyledDropdownMenu = styled(DropdownMenu)`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background-color: #fff;
`;
const StyledIcon = styled(SvgIcon)`
  display: block;
`;
const NavBarDropDown = (_a) => {
  var _b = _a, {
    toggleType = "click",
    toggleIconName = "more",
    items = []
  } = _b, props = __objRest(_b, [
    "toggleType",
    "toggleIconName",
    "items"
  ]);
  const [openPopover, setOpenPopover] = useState(false);
  return /* @__PURE__ */ React.createElement(StyledDropdown, __spreadProps(__spreadValues({}, props), {
    isOpen: openPopover,
    toggle: () => setOpenPopover((prev) => !prev),
    toggleType
  }), /* @__PURE__ */ React.createElement(DropdownToggle, null, /* @__PURE__ */ React.createElement(StyledIcon, {
    name: toggleIconName,
    size: 20,
    color: "#333"
  })), /* @__PURE__ */ React.createElement(StyledDropdownMenu, null, items.map((item, index) => /* @__PURE__ */ React.createElement(DropDownItem, __spreadProps(__spreadValues({
    key: index
  }, item), {
    prefetch: false
  })))));
};
const ItemWrapper = styled.div`
  background-color: #fff;
  text-decoration: none;
`;
const DropDownItem = (_c) => {
  var _d = _c, {
    title,
    iconName
  } = _d, props = __objRest(_d, [
    "title",
    "iconName"
  ]);
  return /* @__PURE__ */ React.createElement(ItemWrapper, __spreadProps(__spreadValues({}, props), {
    as: props.href ? Link : "div"
  }), /* @__PURE__ */ React.createElement(Flex, {
    justify: "start",
    align: "center",
    flexWrap: "nowrap",
    padding: ["s8", "s12"],
    gap: "s12"
  }, /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement(StyledIcon, {
    name: iconName,
    size: 18
  })), /* @__PURE__ */ React.createElement(Text, {
    fontSize: 13
  }, title)));
};

export { DropDownItem, NavBarDropDown };
